import React, { useState, useEffect } from 'react';
import { Translate } from '../../language';
import { connect } from 'react-redux'
import { makePayment  } from '../../actions/userActions';
import useMercadoPago from '../../utils/hooks/useMercadoPago';

const PaymentTest = ({makePayment,isLoadingPaymentUser,paymentUser,  history }) => {
    let idLanding = '5fd4f819ed79e0730df7d43e'
    const [namePayment, setNamePayment] = useState('')
    const [quantityPayment, setQuantityPayment] = useState('')
    const [pricePayment, setPricePayment] = useState('')
    const [id, setId] = useState('')
    const [testId, setTestId] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [idEdit, setIdEdit] = useState('')
    const [indexEdit, setIndexEdit] = useState('')
  
    const resultPayment = useMercadoPago();
   
  //TEST-2209193818842278-122115-67e7ce291d9b12a96460a0cf4b44e5a7-1044116499

    const isEmpty = (e) => {

        const { name, placeholder, value } = e.target;
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        if (value.length !== 0) {

            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }

    }

    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }


    return (
        <div className="container-mark-type-admin">
            <div className="new-edit-type-mark-container-admin">
                <div className='title-admin'>{`${isEdit ? 'Editar' : 'Nuevo'} premio`}</div>
                <div className="container-inputs-new-mark">
                    <div className="text-input-admin">
                        {'Nombre:'}
                    </div>
                    <input
                        name='namePayment'
                        className='inputs-admin'
                        value={namePayment}
                        onChange={(e) => {
                            setNamePayment(e.target.value.trimStart())
                            if (namePayment !== ''  && quantityPayment !== '' && pricePayment !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.namePayment}</div>
                    <div className="text-input-admin">
                        {'Cantidad:'}
                    </div>
                    <input
                        name='quantityPayment'
                        className='inputs-admin'
                        type='number'
                        min='1'
                        value={quantityPayment}
                        onChange={(e) => {
                            setQuantityPayment(e.target.value.trimStart())
                            if ( namePayment !== '' && quantityPayment !== '' && pricePayment !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.quantityPayment}</div>

                    <div className="text-input-admin">
                        {'ID del producto:'}
                    </div>
                    <input
                        name='quantityPayment'
                        className='inputs-admin'
                        value={testId}
                        onChange={(e) => {
                            setTestId(e.target.value.trimStart())
                            if ( namePayment !== '' && quantityPayment !== '' && pricePayment !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.testId}</div>
                    <div className="text-input-admin">
                        {'Precio:'}
                    </div>
                    <input
                        name='pricePayment'
                        className='inputs-admin'
                        value={pricePayment}
                        type='number'
                        min='1'
                        onChange={(e) => {
                            setPricePayment(e.target.value.trimStart())
                            if ( namePayment !== ''  && quantityPayment !== '' && pricePayment !== '') {
                                setValidate(true)
                            }
                        }}
                        onBlur={e => isEmpty(e)}
                        onFocus={e => isFocused(e)}
                        onKeyUp={e => isEmpty(e)}
                    />
                    <div className="text-error text-error-admin">{error.pricePayment}
                    </div>
                </div>
                <div  id="cho-container" className='btn btn-purple' onClick={()=>{
                    
                    
                   
                        
                        
                    
                    
                    }}>pay</div>
            </div>
            <div className="see-all-mark-type-admin">
                <div className='title-admin-list'>Respuesta data</div>
                <div className='wrapper-2 column-gap row-gap mt-3'>
                    {isLoadingPaymentUser ? <div>Cargando...</div> :
                        
                            <div className="card-admin">                                
                                <a className="tittle-card-admin" href={paymentUser}><div>{paymentUser}</div>Ir url</a>
                                <div className="text-content-card"></div>
                                <div className="text-content-card"></div>
                                <div className="column centerContent">

 

                                </div>
                            </div>
                       
                    }
                </div>

            </div>
        </div>
    )
}
const mapStateToProps = (state) => {
    return {
        paymentUser: state.userInfo.paymentUser,
        isLoadingPaymentUser: state.userInfo.isLoadingPaymentUser
    }
}
export default connect(mapStateToProps, {makePayment })(PaymentTest) 
